import React from 'react'

import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { PricingProductStateTagRender } from '@app/components/renderers'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap, columnSettingSchema } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ProductPricingListDataSource } from '../types'

const getOptions = (): Array<Column<ProductPricingListDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(
    key => !['isShortKvi', 'isEPP', 'state'].includes(key)
  ) as Array<keyof ProductPricingListDataSource>

  return columnsKeys.map(key => {
    const column: Column<ProductPricingListDataSource> = {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...columnSettingSchema[key]
    }

    return column
  })
}

export const getColumns = (): Array<Column<ProductPricingListDataSource>> => {
  return getColumnsFromMap<ProductPricingListDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'isShortKvi',
        render: (_, { isShortKvi }) => (isShortKvi ? 'да' : 'нет')
      },
      {
        key: 'isEPP',
        render: (_, { isEPP }) => (isEPP ? 'да' : 'нет')
      },
      {
        key: 'state',
        sorter: (a, b) => sorterDispatcher(a.state, b.state),
        render: (_, { state }) => <PricingProductStateTagRender state={ state } />
      }
    ]
  })
}
